import TrackerProvider from '@fingo/lib/components/tracker/TrackerProvider';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Layout from '@fingo/lib/components/layout/Layout';
import AppRoutes from './AppRoutes';
import WorkspaceNavbar from './components/layout/navbar/WorkspaceNavbar';

const App = () => (
  <Router>
    {/* Estos providers no se pueden dejar atrás porque usan ruteo */}
    <TrackerProvider
      frontendName="banco-de-chile"
    >
      <Layout NavbarComponent={WorkspaceNavbar} defaultBackgroundColor="common.white">
        <AppRoutes />
      </Layout>
    </TrackerProvider>
  </Router>
);

export default App;
